const childRoutes = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/application-list/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/recommended-list/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/approved-list/List.vue')
    },
    {
        path: 'center-change-request-list',
        name: prop + '.center_change_request_list',
        meta: { auth: true },
        component: () => import('../pages/center-change-request-list/List.vue')
    },
    {
        path: 'awareness-info',
        name: prop + '.awareness_info',
        meta: { auth: true },
        component: () => import('../pages/awareness-info/List.vue')
    },
    {
        path: 'patient-report',
        name: prop + '.patient_report',
        meta: { auth: true },
        component: () => import('../pages/patient-report/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/info-management-system',
    name: 'awareness_event_service.info_management_system',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.info_management_system')
}]

export default routes
